import React, { useEffect } from 'react';
import { FiX, FiPrinter } from 'react-icons/fi';
import styles from '../Onboard.module.css';

const MESES = [
  'janeiro','fevereiro','março','abril','maio','junho',
  'julho','agosto','setembro','outubro','novembro','dezembro',
];

function dataExtenso() {
  const d = new Date();
  return `${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`;
}

function substituirVariaveis(template, lead) {
  return template
    .replaceAll('{{nome_cliente}}', lead.nome ?? '')
    .replaceAll('{{empresa}}',      lead.empresa || lead.nome || '')
    .replaceAll('{{telefone}}',     lead.telefone ?? '')
    .replaceAll('{{email}}',        lead.email ?? '')
    .replaceAll('{{servicos}}',     (lead.servicosInteresse ?? []).join(', '))
    .replaceAll('{{data_hoje}}',    dataExtenso())
    .replaceAll('{{responsavel}}',  '');
}

function DocumentoModal({ titulo, templateTexto, lead, onFechar }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onFechar(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onFechar]);

  const conteudo = substituirVariaveis(templateTexto, lead);

  function handleImprimir() {
    const janela = window.open('', '_blank');
    janela.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8">
  <title>${titulo}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Times New Roman', Times, serif;
      font-size: 14pt;
      line-height: 1.9;
      color: #000;
      padding: 3cm 3cm 3cm 3.5cm;
      background: #fff;
    }
    pre {
      font-family: inherit;
      font-size: inherit;
      white-space: pre-wrap;
      word-break: break-word;
    }
    @page { margin: 0; }
  </style>
</head>
<body>
  <pre>${conteudo}</pre>
</body>
</html>`);
    janela.document.close();
    janela.focus();
    setTimeout(() => { janela.print(); janela.close(); }, 300);
  }

  return (
    <div
      className={styles.overlay}
    >
      <div className={styles.documentoModal}>
        {/* Header */}
        <div className={styles.documentoHeader}>
          <div>
            <p className={styles.detalheEmpresa}>{titulo}</p>
            <p className={styles.detalheNome}>{lead.empresa || lead.nome}</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className={styles.btnImprimir} onClick={handleImprimir}>
              <FiPrinter /> Imprimir
            </button>
            <button className={styles.btnFechar} onClick={onFechar} aria-label="Fechar">
              <FiX />
            </button>
          </div>
        </div>

        {/* Página do documento */}
        <div className={styles.documentoPagina}>
          <div className={styles.documentoFolha}>
            <pre className={styles.documentoTexto}>{conteudo}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentoModal;
